import { Box, Link, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CorpTypeList2,
  FacilityKind,
  formClassStaff,
  FormKbn,
  SexFlug,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStrpper from "../../components/atoms/TkStepper";
import TkTable from "../../components/atoms/TkTable";
import TkTitle from "../../components/atoms/TkTitle";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkCsvUpload from "../../components/molecules/TkCsvUpload";
import TkFileUpload from "../../components/molecules/TkFileUpload";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import {
  httpAPI_COM007,
  httpAPI_FAC042,
  httpAPI_STA007,
  httpAPI_STA014,
  httpAPI_STA017,
} from "./api/request";
import { staffInfoHeadTitleList, stepperData } from "./parts";
import { TkGetCode } from "../../utils/TkGetCode";
import { CheckedList } from "../../type/apiType/IAPI_STA007";
import { changeAmountFormat } from "../../utils/useTools";
import "./_style.scss";
import { TkFileUploadFileType } from "../../type/componentsType/TkFileUpload";

/**
 * SCRC060106 職員情報新規登録。
 * @returns JSX.Element SCRC060106 職員情報新規登録
 */
const SCRC060106 = () => {
  const navigate = useNavigate();
  //削除ダイヤログ
  const [openSuccessDelete, setOpenSuccessDelete] = useState(false);
  //一時保存ダイヤログ
  const [openSuccess, setOpenSuccess] = useState(false);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const isUserTypeKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const context = businessState.job_01;
  //ボタンの表示と非表示
  const [showButton, setShowButton] = useState(true);
  // チェック済みリスト
  const [checkedList, setCheckedList] = useState<CheckedList[]>([]);
  const [bodyList, setBodyList] = useState<any>([]);
  const [formList, setFormList] = useState<any>([]);
  const [staffInfo, setStaffInfo] = useState({
    updateDatetime: "",
    staffNo: "",
  });
  const [tempSubmitDisabled, setTempSubmitDisabled] = useState(true);
  const joinCapacityAllEqualA = useRef(false);
  const [checkboxIsChecked, setCheckboxIsChecked] = useState(false);
  const [isAllUpload, setIsAllUpload] = useState(false);
  const [needFileNum, setNeedFileNum] = useState<any>(0);
  const [uploadFile, setUploadFile] = useState<any>([]);
  const [openUploadComplete, setOpenUploadComplete] = useState(false);

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 初期表示
  const handleInit = async () => {
    try {
      const res = await httpAPI_STA017({
        facilityNo: context?.facilityNo,
        applyId: context?.applyId,
        businessType: businessState.common?.businessType,
      });

      if (res.resultCd === "I0000") {
        let needFileNum = res.staffList?.filter(
          (item) => item.joinCapacity === "イ" || item.joinCapacity === "ウ"
        )?.length;
        setNeedFileNum(needFileNum);

        const makeFileObj = (staffNo: any): TkFileUploadFileType[] => {
          let targetFile = res.formList?.find(
            (item) => item.staffNo === staffNo
          )!;

          if (targetFile) {
            let fileObj: TkFileUploadFileType[] = [
              {
                formName: targetFile.fileName!,
                fileBase64: targetFile.fileBase64!,
              },
            ];

            return fileObj;
          }

          return [];
        };

        let bodyList = res.staffList?.map((item) => [
          {
            children: `${item.staffNo}:${item.staffNameKanji}`,
          },
          {
            children: item.birthday,
            align: "center",
          },
          {
            children: TkGetCode(SexFlug, item.sex),
            align: "center",
          },
          {
            children: item.joinCapacity,
            align: "center",
          },
          {
            children: changeAmountFormat(item.salaryTableAmt!),
            align: "right",
          },
          {
            children: changeAmountFormat(item.salaryAdjustmentAmt!),
            align: "right",
          },
          {
            children: (
              <Box className="btnInLine">
                <TkButton
                  data-testid="fixButton"
                  onClick={() => handleEditClick(item.staffNo)}
                >
                  修正
                </TkButton>
                <TkButton
                  data-testid="deleteButton"
                  onClick={() => handleDelete(item)}
                >
                  削除
                </TkButton>
              </Box>
            ),
          },
          {
            children:
              item.joinCapacity === "イ" || item.joinCapacity === "ウ" ? (
                <TkFileUpload
                  data-testid="fileUpload"
                  id={item.staffNo}
                  wantToSetValue={makeFileObj(item.staffNo)}
                  onChange={(e: any) => handleFileChange(e, item.staffNo)}
                />
              ) : (
                <></>
              ),
          },
        ])!;

        setBodyList(bodyList);
        setFormList(res.formList);

        if (
          //持回情報.法人格=学校法人の場合、ボタンを非表示する
          [
            CorpTypeList2["学校法人"],
            CorpTypeList2["学校法人（認定こども園）"],
          ].includes(context?.businessOwnerClass as CorpTypeList2)
        ) {
          setShowButton(false);
        }
        if (
          //持回情報.加入止めフラグまたは、持回情報.部分解除フラグのいずれかが1の場合、ボタンを非表示する
          context?.noJoinFlg === "1" ||
          context?.partialReleaseFlg === "1"
        ) {
          setShowButton(false);
        }
        setCheckboxIsChecked(res.registerCompletedFlg === "1");

        setState({
          ...state,
          errorMsgId: "",
        });
        setBusinessState({
          ...businessState,
          job_01: {
            ...businessState.job_01,
            staffNo: "",
            registrationProcedureInfo: {},
          },
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //ファイルアップロード
  const handleFileChange = (event: any, staffNo: any) => {
    let file = event.target.value?.[0];

    setUploadFile((prev: any) => {
      if (file) {
        let reqFileObj = {
          facilityNo: context?.facilityNo,
          staffNo: staffNo,
          formKbn: FormKbn["職員書類"],
          formClass: formClassStaff["雇用契約書の写し"],
          fileName: file.formName,
          fileBase64: file.fileBase64,
          issueDocumentNo: "",
          issueDate: "",
        };

        if (prev.find((item: any) => item.staffNo === staffNo)) {
          return prev.map((i: any) => (i.staffNo === staffNo ? reqFileObj : i));
        } else {
          return [...prev, reqFileObj];
        }
      } else {
        return prev.filter((i: any) => i.staffNo !== staffNo);
      }
    });
  };

  useEffect(() => {
    let allUploadFlg = needFileNum === 0 || uploadFile?.length === needFileNum;
    setIsAllUpload(allUploadFlg);
    !allUploadFlg && setCheckboxIsChecked(false);
    setTempSubmitDisabled(!uploadFile?.length);
  }, [uploadFile, needFileNum]);

  //職員登録ボタン用イベント
  const handleStaffRegistration = () => {
    setBusinessState({
      ...businessState,
      common: {
        ...businessState.common,
        businessType: "JOB-01",
      },
    });
    navigate("/SCRC060108");
  };

  //修正ボタン
  const handleEditClick = (staffNo: string | undefined) => {
    let applyId = businessState?.job_01?.applyId;

    let businessType = businessState?.common?.businessType;
    setBusinessState({
      ...businessState,
      job_01: {
        ...businessState.job_01,
        applyId,
        staffNo,
      },
      common: {
        ...businessState.common,
        businessType,
      },
    });

    navigate("/SCRC060108");
  };

  const handleDelete = (data: any) => {
    setStaffInfo({
      updateDatetime: data.updateDatetime,
      staffNo: data.staffNo,
    });

    setOpenSuccessDelete(true);
  };

  //削除用APIを呼び出して、その後初期表示するイベント
  const handleOKDelete = async () => {
    try {
      const res = await httpAPI_STA014({
        staffNo: staffInfo.staffNo,
        applyId: businessState?.job_01?.applyId,
        contractorNo: isUserTypeKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        updateDateTime: staffInfo.updateDatetime,
      });

      if (res.resultCd === "I0000") {
        handleInit();
        setOpenSuccessDelete(false);
        setState({ ...state, errorMsgId: "" });
        navigate("/SCRC060106");
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const makeHttpReqObj = (): any => {
    let newFormList = formList.filter((item: any) =>
      uploadFile.some((uploadItem: any) => uploadItem.staffNo === item.staffNo)
    );

    uploadFile.forEach((item: any) => {
      let targetIndex = newFormList.findIndex(
        (i: any) => i.staffNo === item.staffNo
      );
      if (targetIndex !== -1) {
        newFormList[targetIndex] = item;
      } else {
        newFormList.push(item);
      }
    });
    newFormList?.forEach((item: any, index: any) => {
      delete item.serialNo;
      item.seqNumber = index + 1;
    });

    const req = {
      applyId: businessState.job_01?.applyId,
      fileList: newFormList,
    };
    return req;
  };

  // 一時保存
  const onCheckAndSubmit = async () => {
    // 申請等の関連帳票アップロード（汎用）API 呼び出し
    try {
      const res = await httpAPI_COM007({
        ...makeHttpReqObj(),
      });

      if (res.resultCd === "I0000") {
        setOpenSuccess(true);

        setBusinessState({
          ...businessState,
          job_01: {
            ...businessState.job_01,
            tempSaveStep: 2,
          },
        });

        setState({ ...state, errorMsgId: "" });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleOK = () => {
    setOpenSuccess(false);
  };

  // 登録完了
  const handleFileUploadAPI = async () => {
    // すべての職員の加入資格が"ア"の場合
    if (joinCapacityAllEqualA.current) {
      navigate("/SCRC050102");
      return;
    }
    // 申請等の関連帳票アップロード（汎用）API 呼び出し
    try {
      const res = await httpAPI_COM007({
        ...makeHttpReqObj(),
      });

      if (res.resultCd === "I0000") {
        // 職員登録完了更新API呼び出し
        const checkRes = await httpAPI_FAC042({
          applyId: context?.applyId,
          facilityNo: context?.facilityNo,
          businessType: businessState.common?.businessType,
        });
        if (checkRes.resultCd === "I0000") {
          setState({ ...state, errorMsgId: "" });
          navigate("/SCRC050102");
        } else {
          setState({ ...state, errorMsgId: checkRes.resultCd });
        }
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 一括アップロードボタン押下時に更新用APIを呼び出すイベント
  const handleUpload = async (csvData: any) => {
    const staffArr = csvData.map((item: any) => {
      return {
        facilityNo: context?.facilityNo,
        facilityName: item.facilityName,
        staffNameKana: `${item.staffLastNameHalfKana} ${item.staffFirstNameHalfKana}`,
        staffNameKanji: `${item.staffLastName}　${item.staffFirstName}`,
        birthday: item.birthDate,
        sex: item.gender,
        joinDate: context?.desiredContractDate,
        joinCapacity: item.membershipQualification,
        jobCd: item.jobType,
        salaryTableAmt: parseInt(item.salaryScaleAmount),
        salaryAdjustmentAmt: parseInt(item.salaryAdjustmentAmount),
        masPastFlg: item.hasBeenMutualAidStaff,
        masQuitReason: item.reasonForNotBeingMutualAidStaff,
        masQuitDate: item.dateOfNoLongerBeingMutualAidStaff,
        bCorpName: item.previousMutualAidContractorName,
        bContractNo: item.previousMutualAidContractorNumber,
        bStaffNo: item.previousStaffNumber,
      };
    });

    // 新規登録職員一括更新API 呼び出し
    try {
      const res = await httpAPI_STA007({
        contractorNo: isUserTypeKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        applyId: context?.applyId,
        tempSaveStep: context?.tempSaveStep,
        businessType: businessState.common?.businessType,
        staffList: staffArr,
        checkedList: checkedList,
      });

      setCheckedList(res.checkedList || []);

      if (res.resultCd === "I0000") {
        setCheckedList([]);
        setOpenUploadComplete(true);
        handleInit();
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC060106" data-testid="SCRC060106PageForTest">
      <TkStrpper
        steps={stepperData}
        activeStep={1}
        savaStep={context?.tempSaveStep}
      />

      <Box className="infoBox">
        <Typography>
          　当該施設・事業に在籍している
          <span className="boldFont">加入要件を満たす職員は全て登録</span>
          してください。
          <TkHelpIcon
            helpMessage={
              <>
                加入要件については
                <a
                  href={`${
                    process.env.PUBLIC_URL ?? ""
                  }/assets/pdf/≪別紙≫加入要件について.pdf`}
                  target="_blank"
                  rel="noreferrer"
                >
                  こちら
                </a>
                をご確認ください。併せて兼務職員についての考え方についても
                <a
                  href={`${
                    process.env.PUBLIC_URL ?? ""
                  }/assets/pdf/≪別紙≫兼務職員の取り扱いについて.pdf`}
                  target="_blank"
                  rel="noreferrer"
                >
                  こちら
                </a>
                からご確認ください。
              </>
            }
          />
        </Typography>
        <Typography>
          　「兼務職員
          <TkHelpIcon
            helpMessage={
              <>
                兼務職員については
                <a
                  href={`${
                    process.env.PUBLIC_URL ?? ""
                  }/assets/pdf/≪別紙≫兼務職員の取り扱いについて.pdf`}
                  target="_blank"
                  rel="noreferrer"
                >
                  こちら
                </a>
                をご確認ください。
              </>
            }
          />
          」及び「加入要件を満たさない職員」のみの施設・事業であり、加入登録する職員数が「0名」となる施設・事業については、画面下部にある「以下に該当する職員はすべて登録しました」に☑を入れ、「登録完了」ボタンを押してください。
        </Typography>
        <Typography>
          　なお、施設に在籍している加入対象の職員をまとめて一括で登録する場合には、「職員情報登録様式のダウンロード」ボタンを押して、
        </Typography>
        <Typography>
          様式をダウンロード、入力のうえ、「職員情報登録様式のアップロード」ボタンを押して、登録してください。
        </Typography>
      </Box>

      {isUserTypeKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState.common?.contractorNo! +
            ":" +
            businessState.common?.contractorName!
          }
        />
      )}

      <TkTitle size="medium">{`${businessState?.job_01?.facilityNo}:${
        businessState?.job_01?.facilityName
      }　【施設種類】${
        FacilityKind[context?.facilityKind as keyof typeof FacilityKind]
      }`}</TkTitle>
      {showButton && (
        <Box className="leftBtnGroup">
          <TkButton onClick={() => handleStaffRegistration()}>
            職員登録
          </TkButton>
          <Link
            href={`${
              process.env.PUBLIC_URL ?? ""
            }/assets/pdf/職員情報登録様式.xlsm`}
            target="_blank"
            rel="noreferrer"
          >
            <TkButton>職員情報登録様式のダウンロード</TkButton>
          </Link>
          <TkCsvUpload
            buttonName="職員情報登録様式のアップロード"
            type="houjinStaffInfo"
            onSuccess={handleUpload}
          />
        </Box>
      )}

      <TkTable headList={staffInfoHeadTitleList} bodyList={bodyList} showUnit />

      <Box className="checkbox">
        <TkCheckbox
          key="1"
          disabled={!isAllUpload}
          onChange={(e: any) => setCheckboxIsChecked(e.target.checked)}
          label="以下に該当する職員はすべて登録しました"
          checked={checkboxIsChecked}
        />
      </Box>
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC060106_02}</TkInfoManual>

      <Box className="submitBtnGroup">
        <TkBackButton />
        <TkButton onClick={onCheckAndSubmit} disabled={tempSubmitDisabled}>
          一時保存
        </TkButton>
        <TkButton
          data-testid="registerSuccess"
          onClick={handleFileUploadAPI}
          disabled={!checkboxIsChecked}
        >
          登録完了
        </TkButton>
      </Box>

      <TkMessageDialog
        open={openSuccess}
        onOky={handleOK}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />

      <TkMessageDialog
        open={openSuccessDelete}
        onOky={handleOKDelete}
        onCancel={() => setOpenSuccessDelete(false)}
        title="確認（職員情報を削除します）"
        contextText="　職員情報の削除を行いますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
      <TkMessageDialog
        open={openUploadComplete}
        onOky={() => {
          setOpenUploadComplete(false);
        }}
        title="アップロード完了"
        contextText="　アップロードが完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC060106;
